import gql from 'graphql-tag';

export const COMMENTS = gql`
  query comments($id: ID, $type: String) {
    comments(id: $id, type: $type) {
      objects {
        id
        comment
        is_external
        created_at
        user {
          id
          email
          first_name
          is_active
          last_name
          lastLogin
          status
          rights
        }
        uploads {
          id
          storage_key
          mime_type
          original_name
        }
      }
    }
  }
`;
